import _ from "lodash";
export const incrementSubmissionSession = entitySubType => {
  if (!entitySubType) return "SESSION_1";

  const parts = _.split(entitySubType, "_");
  const incrementedNumber = parseInt(parts[1], 10) + 1;

  return _.join([parts[0], incrementedNumber], "_");
};

const _normalizeCheckPoints = attachment => {
  const checkPoints = _.get(attachment, "metadata.checkPoints", []);

  return _.sortBy(
    _.map(checkPoints, checkPoint => ({
      timestamp: checkPoint?.timestamp || "",
      learningMoment: checkPoint?.learningMoment || "",
      reflectiveQuestion: checkPoint?.reflectiveQuestion || "",
    })),
    ["timestamp", "learningMoment", "reflectiveQuestion"]
  );
};

export const areCheckpointsSame = (attachment1, attachment2) => {
  return _.isEqual(
    _normalizeCheckPoints(attachment1),
    _normalizeCheckPoints(attachment2)
  );
};
